import { render } from "./QaboardDetail.vue?vue&type=template&id=a3bc3548&scoped=true"
import script from "./QaboardDetail.vue?vue&type=script&lang=ts"
export * from "./QaboardDetail.vue?vue&type=script&lang=ts"

import "./QaboardDetail.vue?vue&type=style&index=0&id=a3bc3548&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a3bc3548"

export default script